<div class="p-5">
  <div class="flex justify-between items-center mb-2">
    <div class="text-lg text-gray-700 font-bold">Confirmar fase {{ data.fase.numero }} — {{ data.fase.nome }}</div>
    <button class="btn-icon" (click)="close()"><mat-icon>close</mat-icon></button>
  </div>

  <div class="text-sm text-gray-500 mb-4">
    TG {{ data.item.codigoTg }} · OS {{ data.item.codigoOs }}
  </div>

  <div [formGroup]="form" class="flex flex-col gap-1">
    <div class="flex flex-row justify-between items-center w-full">
      <mat-form-field class="input-tg w-6/12 px-2" appearance="outline" hideRequiredMarker>
        <mat-label>Data ocorrido</mat-label>
        <input matInput [matDatepicker]="dataOcorrido" formControlName="dataOcorrido" />
        <mat-datepicker-toggle matSuffix [for]="dataOcorrido"></mat-datepicker-toggle>
        <mat-datepicker #dataOcorrido></mat-datepicker>
      </mat-form-field>
      <mat-form-field class="input-tg w-6/12 px-2" appearance="outline" hideRequiredMarker>
        <mat-label>Hora ocorrido</mat-label>
        <input matInput type="time" formControlName="horaOcorrido" />
      </mat-form-field>
    </div>
    <div class="text-xs text-gray-400 px-2 mb-2">
      Deixe em branco para confirmar agora. Preencha quando o registro for de algo que já aconteceu.
    </div>
    <mat-form-field class="input-tg w-full px-2" appearance="outline" hideRequiredMarker>
      <mat-label>Observação</mat-label>
      <textarea matInput formControlName="observacao" rows="2"></textarea>
    </mat-form-field>
  </div>

  <div class="flex justify-end gap-2 mt-4">
    <button mat-flat-button class="btn-tg-white" (click)="close()">Cancelar</button>
    <button mat-flat-button class="btn-tg" [disabled]="saving" (click)="confirmar()">
      @if (saving) {
        <mat-spinner diameter="20" class="loading-spinner"></mat-spinner>
      } @else {
        Confirmar
      }
    </button>
  </div>
</div>
